import React, { useEffect, useRef, useState } from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Input from "@amzn/meridian/input";
import TimePicker from "@amzn/meridian/time-picker";
import Text from "@amzn/meridian/text";
import { TIME_PATTERN } from "../../../util/Constants";
import { isValidTimeFormat } from "../../SettingsUtil";
import Select, { SelectOption } from "@amzn/meridian/select";
import { SSD_SHIFT_NAME } from "../SettingsConstant";
import Button from "@amzn/meridian/button";
import { ModalFooter } from "@amzn/meridian/modal";
import { chainWalk, isValidNumber } from "../../../util/Util";
import Toaster from "@amzn/meridian/toaster";
import Alert from "@amzn/meridian/alert";
import { WeekdaySelector } from "../../../common/WeekdaySelector";
import {
  getNumericDayOfWeek,
  DAYS_OF_WEEK,
  getLocalizedDayOfWeek,
} from "../../../util/DateTimeUtil";
import Popover, { PopoverHeader } from "@amzn/meridian/popover";

const SHIFT_DISPLAY_NAME = {
  [SSD_SHIFT_NAME.SHIFT_P1]: "P1",
  [SSD_SHIFT_NAME.SHIFT_P2]: "P2",
  [SSD_SHIFT_NAME.SHIFT_P3]: "P3",
  [SSD_SHIFT_NAME.SHIFT_P4]: "P4",
  [SSD_SHIFT_NAME.SHIFT_P5]: "P5",
};

const UpsertShift = ({
  shift,
  allShifts,
  dayOfWeek,
  onSubmit,
  onCancel,
  isEdit,
}) => {
  const [toasts, setToasts] = useState([]);
  const [selectedDays, setSelectedDays] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const confirmButtonRef = useRef();

  const onCloseToast = (id) => setToasts(toasts.filter((t) => t.id !== id));
  const [updatedShift, setUpdatedShift] = useState(
    JSON.parse(JSON.stringify(shift)),
  );

  const onClosePopover = () => setPopoverOpen(false);

  const matchingDays = DAYS_OF_WEEK.filter((dayOfWeek) =>
    allShifts[dayOfWeek].find(
      (shift) => JSON.stringify(shift) === JSON.stringify(updatedShift),
    ),
  ).map(getNumericDayOfWeek);

  const unavailableDays = DAYS_OF_WEEK.filter(
    (dayOfWeek) =>
      !getAvailableShiftNamesForDay(allShifts, dayOfWeek).includes(
        updatedShift.name,
      ),
  )
    .map(getNumericDayOfWeek)
    .filter((dayOfWeek) => !matchingDays.includes(dayOfWeek));

  useEffect(() => {
    setSelectedDays([...new Set([...selectedDays, ...matchingDays])]);
  }, [updatedShift.name]);

  const onChangeShiftName = (val) => {
    setSelectedDays([]);
    setUpdatedShift({
      ...updatedShift,
      name: val,
      label: getShiftLabel(val, updatedShift.start, updatedShift.end),
    });
  };

  const onChangeShiftOrder = (val) => {
    setUpdatedShift({
      ...updatedShift,
      order: val,
    });
  };

  const onChangeCpt = (val) => {
    if (isValidTimeFormat(val, TIME_PATTERN)) {
      setUpdatedShift({
        ...updatedShift,
        primary_cpt: val,
      });
    }
  };
  const onChangeFirstHalfStart = (val) => {
    if (isValidTimeFormat(val, TIME_PATTERN)) {
      setUpdatedShift({
        ...updatedShift,
        first_half_start: val,
        start: val,
        label: getShiftLabel(updatedShift.name, val, updatedShift.end),
      });
    }
  };
  const onChangeFirstHalfEnd = (val) => {
    if (isValidTimeFormat(val, TIME_PATTERN)) {
      setUpdatedShift({
        ...updatedShift,
        first_half_end: val,
      });
    }
  };
  const onChangeBackHalfStart = (val) => {
    if (isValidTimeFormat(val, TIME_PATTERN)) {
      setUpdatedShift({
        ...updatedShift,
        back_half_start: val,
      });
    }
  };
  const onChangeBackHalfSEnd = (val) => {
    if (isValidTimeFormat(val, TIME_PATTERN)) {
      setUpdatedShift({
        ...updatedShift,
        back_half_end: val,
        end: val,
        label: getShiftLabel(updatedShift.name, updatedShift.start, val),
      });
    }
  };

  const onChangeFirstHalfLowerOutboundTphGoal = (val) => {
    if (val === "-" || val < 0) {
      return false;
    }
    updatedShift.first_half_lower_outbound_tph_goal = val;
    setUpdatedShift({ ...updatedShift });
  };
  const onChangeBackHalfLowerOutboundTphGoal = (val) => {
    if (val === "-" || val < 0) {
      return false;
    }
    updatedShift.back_half_lower_outbound_tph_goal = val;
    setUpdatedShift({ ...updatedShift });
  };
  const onChangeFirstHalfUpperOutboundTphGoal = (val) => {
    if (val === "-" || val < 0) {
      return false;
    }
    updatedShift.first_half_upper_outbound_tph_goal = val;
    setUpdatedShift({ ...updatedShift });
  };
  const onChangeBackHalfUpperOutboundTphGoal = (val) => {
    if (val === "-" || val < 0) {
      return false;
    }
    updatedShift.back_half_upper_outbound_tph_goal = val;
    setUpdatedShift({ ...updatedShift });
  };
  const onChangeFirstHalfLowerSortationTphGoal = (val) => {
    if (val === "-" || val < 0) {
      return false;
    }
    updatedShift.first_half_lower_sortation_tph_goal = val;
    setUpdatedShift({ ...updatedShift });
  };
  const onChangeBackHalfLowerSortationTphGoal = (val) => {
    if (val === "-" || val < 0) {
      return false;
    }
    updatedShift.back_half_lower_sortation_tph_goal = val;
    setUpdatedShift({ ...updatedShift });
  };
  const onChangeFirstHalfUpperSortationTphGoal = (val) => {
    if (val === "-" || val < 0) {
      return false;
    }
    updatedShift.first_half_upper_sortation_tph_goal = val;
    setUpdatedShift({ ...updatedShift });
  };
  const onChangeBackHalfUpperSortationTphGoal = (val) => {
    if (val === "-" || val < 0) {
      return false;
    }
    updatedShift.back_half_upper_sortation_tph_goal = val;
    setUpdatedShift({ ...updatedShift });
  };

  const onClickSubmit = () => {
    const daysToSubmit = selectedDays.map((day) => DAYS_OF_WEEK[day]);

    const {
      name,
      order,
      primary_cpt,
      first_half_start,
      first_half_end,
      back_half_start,
      back_half_end,
      start,
      end,
    } = updatedShift;
    const first_half_lower_outbound_tph_goal =
      updatedShift.first_half_lower_outbound_tph_goal;
    const first_half_upper_outbound_tph_goal =
      updatedShift.first_half_upper_outbound_tph_goal;
    const back_half_lower_outbound_tph_goal =
      updatedShift.back_half_lower_outbound_tph_goal;
    const back_half_upper_outbound_tph_goal =
      updatedShift.back_half_upper_outbound_tph_goal;
    const first_half_lower_sortation_tph_goal =
      updatedShift.first_half_lower_sortation_tph_goal;
    const first_half_upper_sortation_tph_goal =
      updatedShift.first_half_upper_sortation_tph_goal;
    const back_half_lower_sortation_tph_goal =
      updatedShift.back_half_lower_sortation_tph_goal;
    const back_half_upper_sortation_tph_goal =
      updatedShift.back_half_upper_sortation_tph_goal;
    if (!name) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please select a shift.`,
        }),
      );
    }
    if (!isValidNumber(order)) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please select a value for shift order`,
        }),
      );
    }
    if (!isValidTimeFormat(primary_cpt, TIME_PATTERN)) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please select the primary CPT time.`,
        }),
      );
    }
    if (!isValidTimeFormat(first_half_start, TIME_PATTERN)) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please select the first half start time.`,
        }),
      );
    }
    if (!isValidTimeFormat(first_half_end, TIME_PATTERN)) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please select the first half end time.`,
        }),
      );
    }
    if (!isValidTimeFormat(back_half_start, TIME_PATTERN)) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please select the second half start time.`,
        }),
      );
    }
    if (!isValidTimeFormat(back_half_end, TIME_PATTERN)) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please select the second half end time.`,
        }),
      );
    }
    if (!isValidTimeFormat(start, TIME_PATTERN)) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please select the shift start time.`,
        }),
      );
    }
    if (!isValidTimeFormat(end, TIME_PATTERN)) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please select the shift end time.`,
        }),
      );
    }
    if (
      !isValidShiftHalfStartAndEndTimes(
        first_half_start,
        first_half_end,
        back_half_start,
        back_half_end,
      )
    ) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please select valid shift half start and end times`,
        }),
      );
    }

    const overlappingShifts = getOverlappingShifts(
      allShifts,
      updatedShift,
      daysToSubmit,
    );
    if (overlappingShifts.length > 0) {
      const [shiftDayOfWeek, overlapDayOfWeek, overlapShift] =
        overlappingShifts[0];

      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Shift for ${shiftDayOfWeek} overlaps with ${overlapDayOfWeek} ${overlapShift}`,
        }),
      );
    }
    if (
      !isValidNumber(first_half_lower_outbound_tph_goal) ||
      first_half_lower_outbound_tph_goal < 0
    ) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please enter a valid lower outbound TPH goal for the first half of the shift.`,
        }),
      );
    }
    if (
      !isValidNumber(first_half_upper_outbound_tph_goal) ||
      first_half_upper_outbound_tph_goal < 0
    ) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please enter a valid upper outbound TPH goal for the first half of the shift.`,
        }),
      );
    }

    if (
      !isValidNumber(back_half_lower_outbound_tph_goal) ||
      back_half_lower_outbound_tph_goal < 0
    ) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please enter a valid lower outbound TPH goal for the second half of the shift.`,
        }),
      );
    }

    if (
      !isValidNumber(back_half_upper_outbound_tph_goal) ||
      back_half_upper_outbound_tph_goal < 0
    ) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please enter a valid upper outbound TPH goal for the second half of the shift.`,
        }),
      );
    }
    if (
      !isValidNumber(first_half_lower_sortation_tph_goal) ||
      first_half_lower_sortation_tph_goal < 0
    ) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please enter a valid lower sortation TPH goal for the first half of the shift.`,
        }),
      );
    }

    if (
      !isValidNumber(first_half_upper_sortation_tph_goal) ||
      first_half_upper_sortation_tph_goal < 0
    ) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please enter a valid upper sortation TPH goal for the first half of the shift.`,
        }),
      );
    }
    if (
      !isValidNumber(back_half_lower_sortation_tph_goal) ||
      back_half_lower_sortation_tph_goal < 0
    ) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please enter a valid lower sortation TPH goal for the second half of the shift.`,
        }),
      );
    }
    if (
      !isValidNumber(back_half_upper_sortation_tph_goal) ||
      back_half_upper_sortation_tph_goal < 0
    ) {
      return setToasts(
        toasts.concat({
          id: Math.random(),
          message: `Please enter a valid upper sortation TPH goal for the second half of the shift.`,
        }),
      );
    }

    onSubmit([...daysToSubmit], {
      ...updatedShift,
      name,
      primary_cpt,
      first_half_start,
      first_half_end,
      back_half_start,
      back_half_end,
      start,
      end,
      first_half_lower_outbound_tph_goal: parseInt(
        first_half_lower_outbound_tph_goal,
        10,
      ),
      first_half_upper_outbound_tph_goal: parseInt(
        first_half_upper_outbound_tph_goal,
        10,
      ),
      back_half_lower_outbound_tph_goal: parseInt(
        back_half_lower_outbound_tph_goal,
        10,
      ),
      back_half_upper_outbound_tph_goal: parseInt(
        back_half_upper_outbound_tph_goal,
        10,
      ),
      first_half_lower_sortation_tph_goal: parseInt(
        first_half_lower_sortation_tph_goal,
        10,
      ),
      first_half_upper_sortation_tph_goal: parseInt(
        first_half_upper_sortation_tph_goal,
        10,
      ),
      back_half_lower_sortation_tph_goal: parseInt(
        back_half_lower_sortation_tph_goal,
        10,
      ),
      back_half_upper_sortation_tph_goal: parseInt(
        back_half_upper_sortation_tph_goal,
        10,
      ),
    });
    onCancel();
  };

  return (
    <Column>
      <React.Fragment>
        <Toaster toasts={toasts} onCloseToast={onCloseToast}>
          {(toast) => (
            <Alert toast={true} onClose={toast.onClose} type="error">
              {toast.message}
            </Alert>
          )}
        </Toaster>
      </React.Fragment>
      <Row width="100%">
        <Column>
          <Text tag="label" type="b200" color="primary">
            Shift *
          </Text>
          <Select
            value={updatedShift.name}
            onChange={onChangeShiftName}
            placeholder="Select a shift"
            width={200}
            disabled={matchingDays > 1}
          >
            {Object.entries(SHIFT_DISPLAY_NAME).map(
              ([shiftName, displayName]) => (
                <SelectOption value={shiftName} label={displayName} />
              ),
            )}
          </Select>
          <Text tag="label" type="b200" color="primary">
            Order *
          </Text>
          <Select value={updatedShift.order} onChange={onChangeShiftOrder}>
            {[...Array(5).keys()].map((index) => (
              <SelectOption value={index} label={index} />
            ))}
          </Select>
          <Text tag="label" type="b200" color="primary">
            Days of Week *
          </Text>
          <WeekdaySelector
            value={selectedDays}
            onChange={setSelectedDays}
            disabledOptions={unavailableDays}
          />
        </Column>
      </Row>
      <Row width="100%" alignmentHorizontal="left">
        <Column>
          <Text tag="label" type="b200" color="primary">
            Primary CPT time *
          </Text>
          <TimePicker
            placeholder="MM:HH"
            value={updatedShift.primary_cpt}
            onChange={onChangeCpt}
            width={200}
          />
        </Column>
      </Row>
      <Row width="100%" alignmentHorizontal="left">
        <Column>
          <Text tag="label" type="b200" color="primary">
            First Half Start *
          </Text>
          <TimePicker
            placeholder="MM:HH"
            value={updatedShift.first_half_start}
            onChange={onChangeFirstHalfStart}
            width={200}
          />
        </Column>
        <Column>
          <Text tag="label" type="b200" color="primary">
            First Half End *
          </Text>
          <TimePicker
            placeholder="MM:HH"
            value={updatedShift.first_half_end}
            onChange={onChangeFirstHalfEnd}
            width={200}
          />
        </Column>
        <Column>
          <Text tag="label" type="b200" color="primary">
            Second Half Start *
          </Text>
          <TimePicker
            placeholder="MM:HH"
            value={updatedShift.back_half_start}
            onChange={onChangeBackHalfStart}
            width={200}
          />
        </Column>
        <Column>
          <Text tag="label" type="b200" color="primary">
            Second Half End *
          </Text>
          <TimePicker
            placeholder="MM:HH"
            value={updatedShift.back_half_end}
            onChange={onChangeBackHalfSEnd}
            width={200}
          />
        </Column>
      </Row>
      <Row spacing="200">
        <Column>
          <Text tag="label" type="b200" color="primary">
            Lower OB TPH Goal *
          </Text>
          <Row alignmentVertical="center">
            <Input
              value={updatedShift.first_half_lower_outbound_tph_goal}
              onChange={onChangeFirstHalfLowerOutboundTphGoal}
              type="number"
              helperText="1H"
              width={100}
            />
            <Text>/</Text>
            <Input
              value={updatedShift.back_half_lower_outbound_tph_goal}
              onChange={onChangeBackHalfLowerOutboundTphGoal}
              type="number"
              helperText="2H"
              width={100}
            />
          </Row>
        </Column>
        &nbsp; &nbsp;
        <Column>
          <Text tag="label" type="b200" color="primary">
            Upper OB TPH Goal *
          </Text>
          <Row alignmentVertical="center">
            <Input
              value={updatedShift.first_half_upper_outbound_tph_goal}
              onChange={onChangeFirstHalfUpperOutboundTphGoal}
              type="number"
              helperText="1H"
              width={100}
            />
            <Text>/</Text>
            <Input
              value={updatedShift.back_half_upper_outbound_tph_goal}
              onChange={onChangeBackHalfUpperOutboundTphGoal}
              type="number"
              helperText="2H"
              width={100}
            />
          </Row>
        </Column>
        &nbsp; &nbsp;
        <Column>
          <Text tag="label" type="b200" color="primary">
            Lower Sort TPH Goal *
          </Text>
          <Row alignmentVertical="center">
            <Input
              value={updatedShift.first_half_lower_sortation_tph_goal}
              onChange={onChangeFirstHalfLowerSortationTphGoal}
              type="number"
              helperText="1H"
              width={100}
            />
            <Text>/</Text>
            <Input
              value={updatedShift.back_half_lower_sortation_tph_goal}
              onChange={onChangeBackHalfLowerSortationTphGoal}
              type="number"
              helperText="2H"
              width={100}
            />
          </Row>
        </Column>
        &nbsp; &nbsp;
        <Column>
          <Text tag="label" type="b200" color="primary">
            Upper Sort TPH Goal *
          </Text>
          <Row alignmentVertical="center">
            <Input
              value={updatedShift.first_half_upper_sortation_tph_goal}
              onChange={onChangeFirstHalfUpperSortationTphGoal}
              type="number"
              helperText="1H"
              width={100}
            />
            <Text>/</Text>
            <Input
              value={updatedShift.back_half_upper_sortation_tph_goal}
              onChange={onChangeBackHalfUpperSortationTphGoal}
              type="number"
              helperText="2H"
              width={100}
            />
          </Row>
        </Column>
      </Row>
      <ModalFooter>
        <Row alignmentHorizontal="end" widths="fit">
          <Button type="secondary" size="small" onClick={onCancel}>
            Close
          </Button>
          <Button
            type="primary"
            size="small"
            ref={confirmButtonRef}
            onClick={() => {
              if (selectedDays.length > 1) {
                setPopoverOpen(true);
              } else {
                onClickSubmit();
              }
            }}
          >
            Confirm
          </Button>
          <Popover
            anchorNode={confirmButtonRef.current}
            position={"top"}
            open={popoverOpen}
            onClose={onClosePopover}
          >
            <PopoverHeader closeButton={onClosePopover}>
              {isEdit ? "Modify" : "Create"} shift for{" "}
              {selectedDays
                .map((day) => getLocalizedDayOfWeek(day, "short"))
                .join(", ")}
              ?
            </PopoverHeader>
            <Row alignmentHorizontal="end">
              <Button
                onClick={() => onClickSubmit()}
              >{`Confirm ${selectedDays.length} day(s)`}</Button>
            </Row>
          </Popover>
        </Row>
      </ModalFooter>
    </Column>
  );
};

const isValidShiftHalfStartAndEndTimes = (
  firstHalfStart,
  firstHalfEnd,
  secondHalfStart,
  secondHalfEnd,
) => {
  if (firstHalfStart === firstHalfEnd || secondHalfStart === secondHalfEnd) {
    return false;
  }
  if (firstHalfStart > firstHalfEnd) {
    return (
      firstHalfEnd <= secondHalfStart &&
      secondHalfStart < secondHalfEnd &&
      secondHalfEnd < firstHalfStart
    );
  } else {
    if (secondHalfStart >= firstHalfEnd) {
      return secondHalfStart < secondHalfEnd || secondHalfEnd < firstHalfStart;
    } else {
      return secondHalfStart < secondHalfEnd && secondHalfEnd < firstHalfStart;
    }
  }
};

const getOverlappingShifts = (allShifts, updatedShift, daysOfWeek) => {
  const overlappingShifts = [];
  daysOfWeek.forEach((dayOfWeek) => {
    const prevDayOfWeek =
      DAYS_OF_WEEK[(((getNumericDayOfWeek(dayOfWeek) - 1) % 7) + 7) % 7];
    const nextDayOfWeek =
      DAYS_OF_WEEK[(getNumericDayOfWeek(dayOfWeek) + 1) % 7];

    const prevDayShifts = allShifts[prevDayOfWeek];
    const nextDayShifts = allShifts[nextDayOfWeek];

    if (updatedShift.start < "12:00") {
      prevDayShifts
        .filter((shift) => shift.start >= "12:00")
        .filter((shift) => shift.end < "12:00")
        .filter((shift) => shift.end > updatedShift.start)
        .map((shift) => [dayOfWeek, prevDayOfWeek, shift.label])
        .forEach((shift) => overlappingShifts.push(shift));
    } else if (updatedShift.end < "12:00") {
      nextDayShifts
        .filter((shift) => shift.start < "12:00")
        .filter((shift) => shift.start < updatedShift.end)
        .map((shift) => [dayOfWeek, nextDayOfWeek, shift.label])
        .forEach((shift) => overlappingShifts.push(shift));
    }
  });

  return overlappingShifts;
};

const getAvailableShiftNamesForDay = (allShifts, dayOfWeek) => {
  return Object.values(SSD_SHIFT_NAME).filter(
    (shiftName) =>
      allShifts[dayOfWeek].filter(({ name }) => name === shiftName).length ===
      0,
  );
};

const getShiftLabel = (shiftName, shiftStart, shiftEnd) => {
  const start = chainWalk(
    () => shiftStart.split(":")[0] + shiftStart.split(":")[1],
    "",
  );
  const end = chainWalk(
    () => shiftEnd.split(":")[0] + shiftEnd.split(":")[1],
    "",
  );
  return `${SHIFT_DISPLAY_NAME[shiftName]} ${start}-${end}`;
};

export default UpsertShift;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ssd/UpsertShift.js